module.exports = __webpack_public_path__ + "static/media/roiback.f06aab7d.jpg";